import type { ImageSourcePropType } from 'react-native';
import type { WebAppVideoPreparation as PreparationPhase } from '@ngsos/portal-core/video';

import { VideoPreparation } from './VideoPreparation';

export type WebAppVideoPreparationProps = {
  phase: PreparationPhase;
  title: string;
  labels: { sms: string; camera: string; location: string };
  images: { sms: ImageSourcePropType; camera: ImageSourcePropType; location: ImageSourcePropType };
  inverse?: boolean;
};

export function WebAppVideoPreparation({ phase, title, labels, images, inverse = false }: WebAppVideoPreparationProps) {
  const actions = phase === 'permissions'
    ? [{ label: labels.camera, image: images.camera }, { label: labels.location, image: images.location }]
    : [{ label: labels[phase], image: images[phase] }];

  return <VideoPreparation title={title} actions={actions.map((action) => ({ ...action, aspectRatio: 948 / 1659 }))} inverse={inverse} testID="incident-video-webapp-preparation-panel" />;
}
